import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class CheckBox extends Component {
  static propTypes = {
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    checked: PropTypes.bool,
  };

  static defaultProps = {
    checked: false,
  };

  toggleCheckbox = e => {
    this.props.onChange(!this.props.checked);
  };

  render() {
    return (
      <div className="pad-half--ends">
        <div className="checkbox">
          <input checked={this.props.checked} onChange={this.toggleCheckbox} type="checkbox" value={this.props.value} id={this.props.value} />
          <span onClick={this.toggleCheckbox} />
          <label className="pad-half--left" htmlFor={this.props.value}>
            {this.props.label}
          </label>
        </div>
      </div>
    );
  }
}
